<!--sub-footer-->
<div class="sub-footer fl-wrap">
    <div class="container">
        <div class="copyright"> &#169; Business in Maharashtra . All rights reserved.</div>

        <div class="subfooter-nav" style="margin-right: 0;">
            <ul class="no-list-style">
                <li><a routerLinkActive="active" routerLink="/contact" title="Contact us">Contact us</a></li>
                <li><a routerLinkActive="active" routerLink="/terms-and-conditions" title="Terms and condition">Terms and condition</a></li>
                <li><a routerLinkActive="active" routerLink="/privacy-policy" title="Privacy Policy">Privacy Policy</a></li>
                <li><a routerLinkActive="active" routerLink="/return-policy" title="Return Policy">Return Policy</a> </li>
                <li><a routerLinkActive="active" routerLink="/refund-and-cancellation" title="Refund and Cancellation">Refund and Cancellation</a> </li>
                <li><a routerLinkActive="active" routerLink="/shipping-policy" title="Shipping and Delivery">Shipping Policy</a> </li>
                <li class="hide"><a routerLinkActive="active" routerLink="news" title="Blog">Blog</a></li>
            </ul>
        </div>
    </div>
</div>
<!--sub-footer end -->